import { accountService } from "@/_services";
import Cookies from "universal-cookie";

const cookies = new Cookies();

export function get(url) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(url),
  };
  return fetch(url, requestOptions);
}

export function getWithParams(url, body) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader(url) },
    //credentials: "include",
    body: JSON.stringify(body),
  };
  return fetch(url, requestOptions);
}

export function post(url, body) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader(url) },
    //credentials: "include",
    body: JSON.stringify(body),
  };
  return fetch(url, requestOptions);
}

export function postMulti(url, data) {
  const requestOptions = {
    method: "POST",
    body: data,
    headers: { ...authHeader(url) },
  };
  return fetch(url, requestOptions);
}

export function put(url, body) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader(url) },
    body: JSON.stringify(body),
  };
  return fetch(url, requestOptions);
}

// prefixed with underscored because delete is a reserved word in javascript
export function _delete(url, body) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(url),
    body: JSON.stringify(body),
  };
  return fetch(url, requestOptions);
}

// helper functions
export function authHeader(url) {
  // return auth header with jwt if user is logged in and request is to the api url
  const user = cookies.get("lifesaferUser");
  const isLoggedIn = user;
  const isApiUrl = url.startsWith(process.env.API_URL);
  if (isLoggedIn && isApiUrl) {
    return { Authorization: `Bearer ${user.jwtToken}` };
  } else {
    return {};
  }
}

export async function handleResponse(response) {
  const user = cookies.get("lifesaferUser");
  if (response.ok) return response.json();
  // 204 - No Content & 404 - Not Found
  // Valid request, but No content found for this request
  if ([204, 404].includes(response.status)) {
    return [];
  }
  // 400 - Bad Request
  if (response.status === 400) {
    const error = await response.text();
    throw new Error(error);
  }
  // 401 - Unauthorized & 403 - Forbidden
  // User isn't authenticated & doesn't have a valid token, log them out, deny access to API
  if ([401, 403].includes(response.status) && user) {
    accountService.logout();
    const error = await response.text();
    throw new Error(error);
  }
  throw new Error("Network response was not ok.");
}

export function handleError(error) {
  console.error("API call failed. " + error);
  throw error;
}
